<div class="d-flex">
  @if (type === 'circle') {
    <i class="fas fa-circle align-self-center mr-2" [ngStyle]="{ 'color': color }"></i>
  }
  @if (type === 'outline-circle') {
    <span class="fas outline-dot align-self-center mr-2" [ngStyle]="{ 'background-color':color, 'border-color': borderColor }"></span>
  }
  @if (type === 'square') {
    <i class="fas fa-square-full align-self-center mr-2" [ngStyle]="{ 'color': color }"></i>
  }
  @if (type === 'line') {
    <div class="align-self-center mr-2" style="height: 2px; width: 1rem;" [ngStyle]="{ 'background-color': color }"></div>
  }
  @if (type === 'circle-line') {
    <i class="fas fa-circle align-self-center" [ngStyle]="{ 'color': color }"></i>
    <div class="align-self-center mr-2" style="height: 2px; width: 1rem;" [ngStyle]="{ 'background-color': color }"></div>
  }
  @if (type === 'dashed') {
    <i class="far fa-ellipsis-h align-self-center mr-2" [ngStyle]="{ 'color': color }"></i>
  }
  @if (disabled) {
    <div [ngStyle]="{ 'color': color }" [ngClass]="{'font-size-small':!reportView,'font-size-very-small':reportView}">
      <del  [class.text-primary]="!showColorLabel">{{ doNotTranslate ? text  : text |translate}}</del>
    </div>
  }
  @if (!disabled) {
    <div [ngStyle]="{ 'color': color }" [ngClass]="{'font-size-small':!reportView,'font-size-very-small':reportView}">
      <span [class.text-font]="!showColorLabel">
        {{ doNotTranslate ? text  : text |translate}}
      </span>
    </div>
  }
</div>